{
  "removeButtonLabel": "Ta bort",
  "removeDescription": "Tryck på Radera för att ta bort taggen."
}
